<template>
  <div>
    <a-form ref="ruleForm" :model="form" :rules="rules">
      <!-- v1先隐藏 -->
      <!-- <div class=" s_over_h ">
        <div class="s_fonts16 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 mb25">
          <p>用户参与策略 <a-tooltip placement='right'>
              <template #title>通过该策略可以设置用户活动领奖的范围
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </p>
        </div>
        <div class="s_ptb0lr24">
          <a-form-item label="领奖限制" :wrapper-col="{span:20}" style="margin-bottom: 0;" help="首次扫码人才能领奖">
            <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_stint_first"></a-switch>
          </a-form-item>
          <a-form-item label="活动参与限制" :wrapper-col="{span:20}" style="margin-bottom: 0;">
            <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_stint_join"></a-switch>
            <a-card :bordered="false" :bodyStyle="{'background-color':'#eeee'}" v-if="form.is_stint_join" class="m-b-30">
              <a-form-item label="每人每天限" :wrapper-col="{span:20}">
                <a-input-number v-model:value="form.stint_day_num"></a-input-number> 次<a-tooltip placement='right'>
                  <template #title>1、可设置每人每天参与当前活动的次数上限；<br />
                    2、若填写为0，则每人每天参与当前活动次数不受限制；
                  </template>
                  <InfoCircleOutlined />
                </a-tooltip>
              </a-form-item>
              <a-form-item label="超次提示" required :wrapper-col="{span:10}">
                <a-textarea showCount :maxlength="50" v-model:value="form.stint_day_num_remark" />
              </a-form-item>
              <a-form-item label="总参与次数" :wrapper-col="{span:20}">
                <a-input-number v-model:value="form.stint_all_num"></a-input-number> 次<a-tooltip placement='right'>
                  <template #title>1、可设置每人每天参与当前活动的次数上限；<br />
                    2、若填写为0，则每人每天参与当前活动次数不受限制；
                  </template>
                  <InfoCircleOutlined />
                </a-tooltip>
              </a-form-item>
            </a-card>
          </a-form-item>
          <a-form-item label="指定用户参与" :wrapper-col="{span:21}" style="margin-bottom: 20;">
            <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_stint_user"></a-switch>
            <a-card :bordered="false" :bodyStyle="{'background-color':'#eeee'}" v-if="form.is_stint_user" class="m-b-30">
              <a-form-item label="选择用户" :wrapper-col="{span:21}" :label-col="{span:3}" required>
                <a-button @click="createUserPloy" class="m-t-20">选择用户</a-button>
                <p v-if="form.user_tag_ids.length">标签: <a-tag color="blue" v-for="v in form.user_tag_ids" :key='v'>{{v.tag_name}}</a-tag>
                </p>
                <p v-if="form.user_vip_ids.length">等级: <a-tag color="blue" v-for="v in form.user_vip_ids" :key='v'>{{v.vip_name}}</a-tag>
                </p>
              </a-form-item>
              <a-form-item label="非指定用户领奖提示" :wrapper-col="{span:10}" :label-col="{span:3}" name="stint_user_remark">
                <a-textarea showCount :maxlength="50" v-model:value="form.stint_user_remark" />
              </a-form-item>
              <p class="fs-12"><span style="color:#acac47">温馨提示</span>:如果同时在[奖品发放策略]中添加了“指定用户发奖”的规则策略,请确保在“指定用户发奖”中添加的客户表情/会员等级在此处也添加了，否则将会影响[奖品发放策略]的正常失效！</p>
            </a-card>
          </a-form-item>
          <a-form-item label="指定地区参与" :wrapper-col="{span:21}" style="margin-bottom: 20;">
            <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_stint_area"></a-switch>
            <a-card :bordered="false" :bodyStyle="{'background-color':'#eeee'}" v-if="form.is_stint_area" class="m-b-30">
              <a-form-item label="选择类型" name="area_type" :label-col="{span:3}">
                <a-radio-group v-model:value="form.stint_area_type">
                  <a-radio :value="1">按行政区域</a-radio>
                  <a-radio :value="2">按GPS</a-radio>
                </a-radio-group>
                <a-tooltip placement='right'>
                  <template #title>1、按经纬度指定了GPS坐标之后，系统将以坐标为中心，以输入的范围为半径来确定活动参与范围，在活动范围内的用户，扫码将发放指定的奖项；<br />
                    2、按GPS坐标指定活动范围可能存在20m左右的误差
                  </template>
                  <InfoCircleOutlined />
                </a-tooltip>
              </a-form-item>
              <a-form-item label="gps" v-if="form.stint_area_type==2" :wrapper-col="{span:20}" :label-col="{span:3}" name="stint_gps_arr">
                <a-button type="primary" @click='showMap=true'>添加指定GPS</a-button>
                <a-table :pagination='false' bordered :columns='gpsColumns' :data-source='form.stint_gps_arr' :scroll="{ x: 'max-content'}">
                  <template v-slot:range="{ record }">
                    <a-input-number :precision="0" v-model:value="record.range" style="width:300px; text-align: center" placeholder="范围" />
                  </template>
                  <template v-slot:action="{ index }">
                    <a-button type="danger" size="small" href="javascript:;" @click="del(index)">删除</a-button>
                  </template>
                </a-table>
              </a-form-item>

              <a-form-item label="行政区域" v-if="form.stint_area_type==1" :wrapper-col="{span:15}" :label-col="{span:3}" name="stint_area_arr">
                <a-row class="m-b-15" type="flex" justify="space-between" align="middle">
                  <a-col :span="8">
                    <div class="">
                      <a-select v-model:value="country" placeholder="请选择">
                        <a-select-option :value="100000">全国</a-select-option>
                      </a-select>
                      <a-select v-model:value="province" allowClear placeholder="请选择省" @change="selectProvince">
                        <a-select-option v-for='(item,index) in provinceList' :key="index" :value="item.id">{{item.name}}
                        </a-select-option>
                      </a-select>
                      <a-select v-model:value="city" allowClear placeholder="请选择市" @change="selectCity">
                        <a-select-option v-for='(item,index) in cityList' :key="index" :value="item.id">{{item.name}}
                        </a-select-option>
                      </a-select>
                      <a-select v-model:value="area" allowClear placeholder="请选择区" @change="selectArea">
                        <a-select-option v-for='(item,index) in areaList' :key="index" :value="item.id">{{item.name}}
                        </a-select-option>
                      </a-select>
                    </div>
                  </a-col>
                  <a-col :span="2">
                    <a-button type="primary" @click="addCity">添加</a-button>
                  </a-col>
                  <a-col :span="8">
                    <div class="s_bor_cbed s_bor10 p-5 height-160" style="overflow-x: auto;overflow-y:scroll">
                      <div class="s_flex_bian_c s_bf58 bor-rad-5 p-tb0-lr10 m-b-10" v-for='(item,index) in form.stint_area_arr' :key='index'>
                        <p>{{item.country_name}}{{item.province_name}}{{item.city_name}}{{item.area_name}}</p>
                        <CloseCircleFilled class="s_c999" v-if='$route.query.type == "look"' />
                        <CloseCircleFilled class="s_c999" @click='delRegion(index)' v-else />
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-form-item>
              <a-form-item label="非活动区域领奖提示" :wrapper-col="{span:10}" :label-col="{span:3}" name="stint_area_remark" >
                <a-textarea showCount :maxlength="50" v-model:value="form.stint_area_remark" />
              </a-form-item>
              <p class="fs-12"><span style="color:#acac47">温馨提示</span>:如果同时在[奖品发放策略]中添加了“指定地区发奖”的规则策略,请确保在“指定地区发奖”中添加的地区范围，否则将会影响[奖品发放策略]的正常失效！</p>
            </a-card>
          </a-form-item>
        </div>
      </div> -->
      <div class=" s_over_h ">
        <div class="s_fonts16 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 mb25">
          <p>数据收集策略 <a-tooltip placement='right'>
              <template #title>通过该策略可以主动收集扫码用户的数据
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </p>
        </div>
        <div class="s_ptb0lr24">
          <a-form-item label="资料收集" :wrapper-col="{span:20}" style="margin-bottom: 20;">
            <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_open_collect_data"></a-switch>
            <a-tooltip placement='right'>
              <template #title>开启资料收集可能会被投诉停止访问，请谨慎开启，详情见 “<a href="http://weixin.qq.com/cgi-bin/readtemplate?t=weixin_external_links_content_management_specification" style="color: #2aae67;" target="_blank">微信新规</a>”
              </template>
              <InfoCircleOutlined class="m-l-10" />
            </a-tooltip>
            <div v-if="form.is_open_collect_data">
              <a-form-item label="条件设置" name="collect_data_second" help="(限1~100整数)">
                第
                <a-input-number class="m-l-5 m-r-5" :min="1" :max="100" :precision="0" v-model:value="form.collect_data_second" /> 次扫码领奖时收集用户资料 <a-tooltip placement='right'>
                  <template #title>过该策略可以实现指定用户发奖、指定地区发奖、指定时间段发奖等功能，实现精准营销
                  </template>
                  <InfoCircleOutlined />
                </a-tooltip>
              </a-form-item>
              <a-form-item label="收集字段" required>
                <a-checkbox-group v-model:value="form.customize_id">
                  <template v-for="v in custimizesList" :key="v.id">
                    <a-checkbox :value="String(v.id)" :checked="v.is_select">{{v.customize_name}}</a-checkbox>
                  </template>
                </a-checkbox-group>
                <a href="javascript:;" @click="visible=true">新增自定义字段</a>
              </a-form-item>
              <a-form-item label="温馨提示" :wrapper-col="{span:10}">
                <a-radio-group name="is_open_collect_tip" v-model:value="form.is_open_collect_tip">
                  <a-radio :value="0">隐藏</a-radio>
                  <a-radio :value="1">显示</a-radio>
                </a-radio-group>
                <a-textarea v-if='form.is_open_collect_tip' showCount :maxlength="50" :rows="4" v-model:value="form.collect_tip" />
              </a-form-item>
              <a-form-item label="更新会员资料" :wrapper-col="{span:10}">
                <a-radio-group name="is_update_user_info" v-model:value="form.is_update_user_info">
                  <a-radio :value="1">是</a-radio>
                  <a-radio :value="0">否</a-radio>
                  <a-tooltip placement='right'>
                    <template #title>1.是：收集资料时会根据收集的资料信息更新会员基础信息（更新基础字段）<br/>
                      2.否：收集资料时不更新会员的基础信息
                    </template>
                    <InfoCircleOutlined />
                  </a-tooltip>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="重复收集资料" :wrapper-col="{span:10}">
                <a-radio-group name="is_repeat_collect" v-model:value="form.is_repeat_collect">
                  <a-radio :value="1">是</a-radio>
                  <a-radio :value="0">否</a-radio>
                  <a-tooltip placement='right'>
                    <template #title>1.是：无论之前有没有填写过资料收集，本次活动都一定会弹出收集资料的窗口<br/>
                      2.否：如果本次活动收集的字段与之前的活动收集字段相同，则不会弹出收集资料窗口；如果本次活动存在新的未收集资料的字段，则会弹出资料收集窗口
                    </template>
                    <InfoCircleOutlined />
                  </a-tooltip>
                </a-radio-group>
              </a-form-item>
            </div>
          </a-form-item>
        </div>
      </div>
      <div class=" s_over_h ">
        <div class="s_fonts16 s_hei60 s_ptb0lr24 s_flex_ali  s_bf58 s_c333 mb25">
          <p>奖品发放策略 <a-tooltip placement='right'>
              <template #title>通过该策略可以实现二维码流量入口功能倍数放大，以及指定用户、指定地区、指定时间段、指定门店等实现营销资源精准投放
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </p>
        </div>
        <div class="s_ptb0lr24" v-if="template_type!=2&&template_type!=4">
          <a-form-item label="一码多奖" :wrapper-col="{span:20}">
            <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_many_awards"></a-switch>
            <a-tooltip placement='right'>
              <template #title>
                设置同一个二维码的扫码人数，并设置商品社交属性的分享扫码奖励，同一用户限扫码一次有效。<br/>
                1、条码首次扫码不参与一码多奖奖品逻辑；<br/>
                2、除首次扫码外，每一用户首次扫码一次扣减一次扫码次数，且扫码用户可获得一码多奖（分享礼包）奖品。
              </template>
              <InfoCircleOutlined class="m-l-10" />
            </a-tooltip>
            <div v-if="form.is_many_awards">
              <a-form-item label="商品扫码次数" name="many_awards_num">
                <a-input-number v-model:value="form.many_awards_num" :precision="0"></a-input-number>
              </a-form-item>
              <a-form-item label="奖品设置" require name="many_awards_type" style="margin-bottom: 0;">
                <!-- <a-radio-group name="many_awards_type" v-model:value="form.many_awards_type">
                  <a-radio :value="1">使用本次活动奖项概率</a-radio>
                  <a-radio :value="2">单独设置</a-radio>
                </a-radio-group> -->
                <div>
                  <a-checkbox v-model:checked="form.many_is_bonus" @change="(e)=>changAwardContent(e,'many_is_bonus')">红包</a-checkbox>
                  <a-checkbox v-model:checked="form.many_is_point" @change="(e)=>changAwardContent(e,'many_is_point')">积分</a-checkbox>
                  <a-checkbox v-model:checked="form.many_is_gift" @change="(e)=>changAwardContent(e,'many_is_gift')">礼品</a-checkbox>
                  <a-checkbox v-model:checked="form.many_is_coupon" @change="(e)=>changAwardContent(e,'many_is_coupon')">优惠卷</a-checkbox>
                </div>
                <a-tabs v-if="panes.length" style="margin-top:10px">
                  <a-tab-pane v-for="pane in panes" :key="pane.key" :tab="pane.title">
                    <div v-show="pane.type=='many_is_point'">
                      <isPoint :point_num="form.many_point_num" v-model:value="form.many_point_num" ref="point" />
                    </div>
                    <div v-show="pane.type=='many_is_bonus'">
                      <isBonus ref="bonus" v-model:value="form.many_bonus_id" v-model:content="form.many_bonus_content" :bonus_id="form.bonus_id" :bonus_content="form.many_bonus_content" />
                    </div>
                    <div v-show="pane.type=='many_is_gift'">
                      <!-- <isGift ref="bonus" v-model:value="form.many_bonus_id" v-model:content="form.many_bonus_content" :bonus_id="form.bonus_id" :bonus_content="form.many_bonus_content" /> -->
                      <isGift :giftDetail="form.gift_info" ref="giftCompoents" :isReal="true" v-on:giftDone="giftDone" />
                    </div>
                    <div v-show="pane.type=='many_is_coupon'">
                      <isCoupon ref="couponCompoents" v-model:couponName="form.many_coupon_name" v-model:content="form.many_coupon_content" :content="form.many_coupon_content" :couponName="form.many_coupon_name" v-on:onchange="onchangeCoupon" />
                    </div>
                  </a-tab-pane>
                </a-tabs>
              </a-form-item>
            </div>
          </a-form-item>
          <!-- <a-form-item label="未中奖提示" name="ploy_remark">
            <a-textarea showCount v-model:value="form.ploy_remark" :maxlength="50" style="width:300px" />
          </a-form-item> -->
          <a-form-item label="奖品发放策略" name="is_ploy" :wrapper-col="{span:20}">
            <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="form.is_ploy"></a-switch>
            <div v-if="form.is_ploy">
              <div class="m-b-10 ">
                <a-button type="primary" @click="ploysVisible=true">新增策略</a-button>
              </div>
              <a-table :pagination='false' :loading='listLoading' :customRow="customRow" bordered rowKey='ploy_id' :columns='columns' :data-source='data'>
                <template v-slot:rule_name_arr="{ record }">
                  <p v-for="v in record.rule_name_arr" :key="v">{{v}}</p>
                </template>
                <template v-slot:award_name_arr="{ record }">
                  <p v-for="v in record.award_name_arr" :key="v">{{v}}</p>
                </template>
                <template v-slot:action="{ record }">
                  <a-popconfirm title="确定要删除该策略么？" @confirm="ployDel(record)" ok-text="删除" cancel-text="取消" placement="topRight">
                    <a-button type="danger" class="m-t-20">删除</a-button>
                  </a-popconfirm>
                  <a-button type="primary" class="m-l-10" @click="ployStatus(record)">{{record.is_enable?'禁用':'启用'}}</a-button>
                  <a-button type="primary" class="m-l-10" @click="editPloy(record)">编辑</a-button>
                </template>
              </a-table>
              <p class="p-10">
                温馨提示：<br />1、上方列表中的规则策略将会根据优先级生效，排序越前（可鼠标拖动进行排序），优先级越高；<br />2、用户扫码领奖时系统将会根据列表的优先级进行逐条判断，判断到符合扫码用户的规则策略时，系统将会根据策略中的设置进行发奖，若所有策略都不符合，则会按照活动第三步中的奖项及概率发奖（勾选了“仅策略发奖”的奖项会过滤掉）进行发奖；<br />3、当规则策略中设置的奖项，其发放数量全部达到上限或奖项本身的数量全部发放完了之后，相应的规则策略将会自动停用（即失效）；
              </p>
            </div>
          </a-form-item>
        </div>
      </div>
      <div class="s_flex_center">
        <a-button @click="provide()" class="m-t-20 m-r-20">上一步</a-button>
        <a-button type="danger" @click="submit(1)" class="m-t-20 m-r-20">保存并启用</a-button>
        <a-button type="primary" @click="submit(0)" class="m-t-20">保存不启用</a-button>
      </div>
    </a-form>
    <a-modal :keyboard="false" v-model:visible="visible" title="字段列表" centered :width='1000' @ok="getcustimizesList();visible=false" destroyOnClose :bodyStyle="{'height':'80vh','overflowY': 'scroll'}">
      <custimizes />
    </a-modal>
    <a-modal :keyboard="false" v-model:visible="ploysVisible" title="奖品发放策略" centered :width='1300' :footer="null" @ok="ploysVisible=false" @cancel="done" destroyOnClose>
      <ploys v-on:done="done" :activity_id="activity_id" ref="ploysComponents" />
    </a-modal>
    <a-modal :keyboard="false" v-model:visible="userVisible" title="选择用户" centered :width='1300' :footer="null" @ok="ploysVisible=false" @cancel="done">
      <user v-on:ployDone="ployUserDone" ref="userComponents" :ployDetail="ployDetail" />
    </a-modal>
    <!-- gps -->
    <a-modal :keyboard="false" title="选择经纬度" centered v-model:visible="showMap" :width='1000' :footer="null" destroyOnClose>
      <gdmap v-on:confirm="gpsConfirm"></gdmap>
    </a-modal>
  </div>
</template>
<script>
import { InfoCircleOutlined, CloseCircleFilled } from "@ant-design/icons-vue";
import isPoint from "../setpsTree/components/isPoint";
import isBonus from "../setpsTree/components/isBonus";
import isGift from "../setpsTree/components/isGift";
import isCoupon from "../setpsTree/components/isCoupon";
import user from "./components/user.vue";
import { inject, onMounted, reactive, ref, toRefs, unref } from "vue";
import { getArea } from "@/api/public";
import {
  activitysFourCustomizesSelectList,
  activitysFourDetail,
  activitysFourUpdate,
  activitysFourPloysList,
  activitysFourPloysDel,
  activitysFourPloysStatus,
  updatePloySort,
} from "@/api/qrcodeActivitys";
import { iscode } from "@/utils/app";
import custimizes from "../custimizes/index";
import ploys from "./components/ploys";
import { message } from "ant-design-vue";
const rules = {
  ploy_name: [{ required: true, message: "请输入策略名称" }],
  many_awards_num: [
    { required: true, message: "请输入扫码次数", type: "number" },
  ],
  ploy_remark: [{ required: true, message: "请输入未中奖提示" }],
  collect_data_second: [
    { message: "请输入第几次扫码时采集资料", required: true },
  ],
  stint_user_remark: [{ message: "请输入非指定用户领奖提示", required: true }],
  stint_area_remark: [{ message: "请输入非活动区域领奖提示", required: true }],
  stint_area_arr: [
    { message: "请选择活动区域", required: true, type: "array" },
  ],
  stint_gps_arr: [{ message: "请选择活动区域", required: true, type: "array" }],
};
export default {
  name: "setpsFour",
  components: {
    InfoCircleOutlined,
    isPoint,
    isBonus,
    isGift,
    custimizes,
    ploys,
    user,
    isCoupon,
  },
  props: {
    activity_id: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  setup(props, { emit }) {
    const ruleForm = ref();
    const form = ref({
      ploy_name: "",
      many_coupon_name: "",
      many_coupon_content: "",
      is_many_awards: 1,
      // many_awards_type: 1,
      many_awards_num: null, //扫码次数
      is_open_collect_data: null, //是否开启资料收集
      customize_id: [], //自定义字段
      collect_data_second: "", //第几次扫码的时候采集资料
      many_is_bonus: "",
      many_is_point: "",
      many_bonus_id: "",
      many_point_num: "",
      stint_day_num: -1,
      stint_all_num: -1, //总参与次数
      stint_day_num_remark: "抱歉,您已经超过活动当日参与次数上限,请明天再试", //每人每天限领超次提示
      stint_all_num_remark:
        "抱歉,您已经超过活动总次数上限,敬请期待新一期活动！", //总次数限领超次提示
      is_stint_first: false,
      is_stint_join: false,
      is_stint_user: false, //是否指定用户参与
      is_stint_area: false, //是否指定地区参与
      stint_area_type: false, //指定地区类型
      stint_area_arr: [], //地区数组
      stint_gps_arr: [], //gps数组
      stint_user_remark: "哦噢,您不符合本次活动的参与条件", //非指定用户领奖提示
      stint_area_remark: "哦噢,您不在本次活动指定的地区,无法参与活动", //非活动区域领奖提示
      stint_gps_remark: "哦噢,您不在本次活动指定的地区,无法参与活动", //非gps区域领奖提示
      status: "",
      user_tag_ids: [], //限制的用户类型标签
      user_vip_ids: [], //限制的用户等级标签
      collect_tip: "",
      is_open_collect_tip: 0,
      many_gift_store_array: [], //门店数组
      many_gift_is_appoint_store: [], //指定门店数组
      many_gift_id: "", //一码多奖礼品
      many_gift_content: "", //礼品框内容
      many_gift_is_express: 1, //默认1 暂时只有快递
      many_gift_express_id: 1, //默认1 暂时不走运费
      many_gift_express_content: "", //快递内容
      many_is_gift: "", //礼品类型 礼品-产品
      gift_info: {}, //一码多奖礼品 与子组件通信使用
      many_gift_effective_day: "", //礼品有效期
      is_update_user_info:1,//是否更新会员资料
      is_repeat_collect:1,//是否重复收集资料
    });
    //<!-- 1'普通模板':2'云店模板'3'溯源模板'4大转盘 -->
    const template_type = ref(2);
    const detail = async () => {
      let result = await activitysFourDetail(props.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        // 获取模板类型
        template_type.value = inject("template_type");
        form.value = result.data;
        form.value.collect_tip = String(form.value.collect_tip || "");
        // 整理一码多奖字段 映射
        if (form.value.many_awards_data && form.value.is_many_awards) {
          form.value.is_many_awards = 1;
          // form.value.many_awards_type=form.value.many_awards_data.awards_type
          form.value.many_awards_num = Number(
            form.value.many_awards_data.awards_num
          );
          if (form.value.many_awards_data.is_bonus) {
            form.value.many_bonus_id =
              form.value.many_awards_data.bonus_info.bonus_id;
            form.value.many_bonus_content =
              form.value.many_awards_data.bonus_info.award_content;
            form.value.bonus_id =
              form.value.many_awards_data.bonus_info.bonus_id;
            form.value.many_is_bonus = 1;
            setTimeout(() => {
              panes.value.push({
                title: "红包",
                type: "many_is_bonus",
                key: "many_is_bonus",
              });
            }, 100);
          }
          if (form.value.many_awards_data.is_gift) {
            form.value.many_is_gift = 1;
            form.value.gift_info = form.value.many_awards_data.gift_info;
            // form.value.gift_info.gift_effective_day=form.value.many_awards_data.gift_info.gift_effective_day
            setTimeout(() => {
              panes.value.push({
                title: "礼品",
                type: "many_is_gift",
                key: "many_is_gift",
              });
            }, 100);
          }
          if (form.value.many_awards_data.is_point) {
            form.value.many_is_point = 1;
            form.value.many_point_num =
              form.value.many_awards_data.point_info.point_num;
            panes.value.push({
              title: "积分",
              type: "many_is_point",
              key: "many_is_point",
            });
          }
          if (form.value.many_awards_data.is_coupon) {
            form.value.many_is_coupon = 1;
            form.value.many_coupon_name =
              form.value.many_awards_data.coupon_info.coupon_name;
            form.value.many_coupon_content =
              form.value.many_awards_data.coupon_info.coupon_content;

            panes.value.push({
              title: "优惠卷",
              type: "many_is_coupon",
              key: "many_is_coupon",
            });
          }
        } else {
          // form.value.many_awards_type=1
        }
        form.value.is_open_collect_data = form.value.is_open_collect_data
          ? 1
          : 0;
        form.value.is_ploy = form.value.is_ploy ? 1 : 0;
        // json字符串 解析
        // form.value.user_tag_ids =
        //   form.value.user_tag_ids && JSON.parse(form.value.user_tag_ids) || [];
        // form.value.user_vip_ids =
        //   form.value.user_vip_ids && JSON.parse(form.value.user_vip_ids) || [];

        // form.value.stint_area_arr =
        //   form.value.stint_area_arr && JSON.parse(form.value.stint_area_arr) ||[];

        //  form.value.stint_gps_arr =
        //   form.value.stint_gps_arr && JSON.parse(form.value.stint_gps_arr) || [];
        //   console.log(form.value.stint_gps_arr)
        form.value.customize_id = result.data.customize_ids;
      }
    };
    const onchangeCoupon = (e) => {
      console.log(e, 232323);
    };
    onMounted(() => {
      detail();
    });
    const custimizesList = ref([]);
    const getcustimizesList = async () => {
      let result = await activitysFourCustomizesSelectList(props.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        custimizesList.value = result.data;
        console.log(custimizesList.value);
      }
    };
    getcustimizesList();
    // 奖项面板
    const panes = ref([]);
    // 切换奖项内容checkBox
    const changAwardContent = (e, type) => {
      if (e.target.checked) {
        panes.value.push({
          title:
            type == "many_is_point"
              ? "积分"
              : type == "many_is_gift"
              ? "礼品"
              : type == "many_is_coupon"
              ? "优惠卷"
              : "红包",
          type: type,
          key: type,
        });
      } else {
        panes.value = panes.value.filter((v) => v.type != type);
      }
    };
    // 指定用户开始----
    const userComponents = ref();
    const userVisible = ref(false);
    const createUserPloy = () => {
      userVisible.value = true;
      if (form.value.user_tag_ids.length || form.value.user_vip_ids.length) {
        setTimeout(() => {
          userComponents.value.renderDetail(
            {
              label: form.value.user_tag_ids,
              vip: form.value.user_vip_ids,
            },
            0
          );
        }, 100);
      }
    };
    const ployUserDone = (e) => {
      form.value.user_tag_ids = e.user_label_id;
      form.value.user_vip_ids = e.user_vip_id;
      console.log(e);
      userVisible.value = false;
    };
    // 指定用户结束----
    // -----------------资料收集start-------
    const visible = ref(false);
    const provide = () => {
      emit("setpsFourProvide", 1);
    };
    const $router = inject("$router");
    // 礼品选择组件
    const giftChooseData = ref({});
    const giftDone = (data) => {
      console.log(data);
      giftChooseData.value = data;
    };
    const giftCompoents = ref();
    const submit = async (is_open) => {
      ruleForm.value
        .validate()
        .then(async (res) => {
          // if (form.value.is_many_awards&&form.value.many_is_gift&&form.value.many_awards_type==2) {
          if (form.value.is_many_awards && form.value.many_is_gift) {
            // 获取子组件的数据

            if (!giftChooseData.value) {
              message.error("请完善礼品表单");
              return;
            }
            form.value.many_is_gift = 1;
            form.value.many_gift_id = giftChooseData.value.gift_id;
            form.value.many_gift_content = giftChooseData.value.gift_content;
            form.value.many_gift_type = giftChooseData.value.gift_type;
            if (giftChooseData.value.gift_receive_award_type == 0) {
              message.error("请选择礼品的领奖方式!");
              return;
            }
            form.value.many_gift_is_express =
              giftChooseData.value.gift_is_express;
            form.value.many_gift_is_store = giftChooseData.value.gift_is_store;
            form.value.many_gift_effective_day =
              giftChooseData.value.gift_effective_day;
          } else {
            form.value.many_is_gift = 0;
          }
          if (form.value.many_is_coupon) {
            form.value.many_is_coupon = 1;
          }
          form.value.is_open_collect_data = form.value.is_open_collect_data
            ? 1
            : 0;
          form.value.is_many_awards = form.value.is_many_awards ? 1 : 0;
          form.value.is_ploy = form.value.is_ploy ? 1 : 0;
          let result = await activitysFourUpdate(props.activity_id, {
            ...form.value,
            is_open,
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            $router.go(-1);
          }
        })
        .catch((error) => {
          console.log(error);
          form.value.is_open_collect_data = form.value.is_open_collect_data
            ? 1
            : 0;
          form.value.is_many_awards = form.value.is_many_awards ? 1 : 0;
          form.value.is_ploy = form.value.is_ploy ? 1 : 0;
          message.error("请完善表单!");
        });
    };
    // ---------------- 资料收集end---------

    // ---------------- 策略start-----------
    // table 加载框
    const listLoading = ref(false);
    const ploysVisible = ref(false);
    const ploysComponents = ref();
    const data = ref([]);
    let columns = [
      {
        title: "优先级",
        dataIndex: "sort_level",
        key: "sort_level",
      },
      {
        title: "名称",
        dataIndex: "ploy_name",
        key: "ploy_name",
      },
      {
        title: "规则策略",
        dataIndex: "rule_name_arr",
        key: "rule_name_arr",
        slots: { customRender: "rule_name_arr" },
      },
      {
        title: "奖项设置",
        dataIndex: "award_name_arr",
        key: "award_name_arr",
        slots: { customRender: "award_name_arr" },
      },
      {
        title: "状态",
        dataIndex: "is_enable",
        key: "is_enable",
        customRender: ({ record }) => {
          return record.is_enable ? "启用" : "禁用";
        },
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    const getPloysList = async () => {
      listLoading.value = true;
      let result = await activitysFourPloysList(props.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      listLoading.value = false;
      if (iscode(result)) {
        data.value = result.data;
      }
    };
    // 删除策略
    const ployDel = async (data) => {
      let result = await activitysFourPloysDel(data.ploy_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        getPloysList();
      }
    };
    getPloysList();
    const done = () => {
      getPloysList();
      ploysVisible.value = false;
    };
    // 启用禁用
    const ployStatus = async (record) => {
      let result = await activitysFourPloysStatus(record.ploy_id, {
        is_enable: record.is_enable ? 0 : 1,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        getPloysList();
      }
    };
    var sourceObj = {};
    var targetObj = {};
    // 拖动
    const customRow = (record, index) => {
      return {
        // 鼠标移入
        onmouseenter: (event) => {
          // 兼容IE
          sourceObj = {};
          targetObj = {};
          var ev = event || window.event;
          ev.target.draggable = true;
        },
        ondragstart: (event) => {
          // 兼容IE
          var ev = event || window.event;
          // 阻止冒泡
          ev.stopPropagation();
          // 得到源目标数据
          sourceObj = unref(record);
          console.log(record);
        },
        // 拖动元素经过的元素
        ondragover: (event) => {
          // 兼容 IE
          var ev = event || window.event;
          // 阻止默认行为
          ev.preventDefault();
        },
        // 鼠标松开
        ondrop: async (event) => {
          // 兼容IE
          var ev = event || window.event;
          // 阻止冒泡
          ev.stopPropagation();
          // 得到目标数据
          targetObj = unref(record);
          let target = await updatePloySort(sourceObj.ploy_id, {
            ...sourceObj,
            sort_level: targetObj.sort_level,
          })
            .then((res) => res.data)
            .catch((error) => error);
          let source = await updatePloySort(targetObj.ploy_id, {
            ...targetObj,
            sort_level: sourceObj.sort_level,
          })
            .then((res) => res.data)
            .catch((error) => error);
          getPloysList();
        },
      };
    };
    // 修改
    const editPloy = (data) => {
      ploysVisible.value = true;
      setTimeout(() => {
        ploysComponents.value.detail(data.ploy_id);
      }, 100);
    };
    // ----------------  策略end-------------
    // 指定地区参与
    const _lodash = inject("_lodash");
    const state = reactive({
      province: undefined,
      scity: undefined,
      city: undefined,
      area: undefined,
      sarea: "",
      provinceList: [],
      cityList: [],
      areaList: [],
      cityObj: {},
      rigthArr: [],
    });
    //获取省市区
    const getAreaList = async (arr) => {
      let result = await getArea().then((res) => res);
      state.provinceList = result.data;
      state.addressList = result.data;
    };
    getAreaList();
    // 销售区域选择省
    const selectProvince = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityList = state.provinceList[option.key].children;
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          province_name: state.provinceList[option.key].name,
          city_name: "",
          area_name: "",
          id: [e],
        };
      } else {
        state.cityList = [];
        state.areaList = [];
        state.province = undefined;
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          province_name: "",
          city_name: "",
          area_name: "",
          id: [],
        };
      }
    };
    // 销售区域选择市
    const selectCity = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityObj.id.splice(1, 2);
        state.areaList = state.cityList[option.key].children;
        state.area = undefined;
        state.cityObj.id.push(e);
        state.cityObj = {
          ...state.cityObj,
          city_name: state.cityList[option.key].name,
          area_name: "",
        };
      } else {
        state.cityObj.id.splice(1, 2);
        state.areaList = [];
        state.city = undefined;
        state.area = undefined;
        state.cityObj = {
          ...state.cityObj,
          city_name: "",
          area_name: "",
        };
      }
    };
    // 销售区域选择区
    const selectArea = (e, option) => {
      if (_lodash.indexOf(state.cityObj.id, 100000) !== -1) {
        state.cityObj.id = _lodash.filter(state.cityObj.id, function (o) {
          return o != 100000;
        });
      }
      if (e && option) {
        state.cityObj.id.splice(2, 1);
        state.cityObj.id.push(e);
        state.cityObj = {
          ...state.cityObj,
          area_name: state.areaList[option.key].name,
        };
      } else {
        state.area = undefined;
        state.cityObj.id.splice(2, 1);
        state.cityObj = {
          ...state.cityObj,
          area_name: "",
        };
      }
    };
    // 清空
    const clearCityArr = () => {
      state.province = "";
      state.city = "";
      state.area = "";
      state.cityList = [];
      state.areaList = [];
      state.cityObj = {
        country_name: "",
        province_name: "",
        city_name: "",
        area_name: "",
        id: [],
      };
    };
    // 添加销售区域
    const addCity = () => {
      var left = state.cityObj; //左边数组
      var right = form.value.stint_area_arr || []; //右边数组
      if (_lodash.indexOf(left.id, 100000) !== -1) {
        left.id = _lodash.filter(left.id, function (o) {
          return o != 100000;
        });
      }
      if (left.id.length == 0) {
        left.id.unshift(100000);
        left.country_name = "全国";
        if (right.length == 0) {
          right.push(_lodash.cloneDeep(left));
          clearCityArr();
        } else {
          message.error("已有相同区域！");
        }
        return;
      }
      if (right.length == 0) {
        left.id.unshift(100000);
        right.push(_lodash.cloneDeep(left));
        form.value.stint_area_arr = right;
        clearCityArr();
        return false;
      } else {
        left.id.unshift(100000);
        for (var i in right) {
          if (left.country_name == "全国" || right[i].country_name == "全国") {
            message.error("已有相同区域！");
            return false;
          }
          if (
            right[i].province_name == left.province_name &&
            right[i].city_name == left.city_name &&
            right[i].area_name == left.area_name
          ) {
            message.error("已有相同区域！");
            return false;
          }
          if (
            right[i].province_name == left.province_name &&
            right[i].city_name == left.city_name
          ) {
            if (right[i].id.length !== left.id.length) {
              message.error("已有相同区域！");
              return false;
            }
          }
          if (right[i].province_name == left.province_name) {
            if (right[i].city_name == "" || left.city_name == "") {
              message.error("已有相同区域！");
              return false;
            }
          }
        }
      }
      right.push(_lodash.cloneDeep(left));
      console.log(right);
      form.value.stint_area_arr = right;
      clearCityArr();
    };
    // 删除销售区域
    const delRegion = (e) => {
      form.value.stint_area_arr.splice(e, 1);
    };

    // gps
    // 经纬度选择完毕
    const mpaState = reactive({
      showMap: false,
    });
    const gpsConfirm = (value) => {
      value.range = 0;
      if (form.value.stint_gps_arr) {
        form.value.stint_gps_arr.push(value);
      } else {
        form.value.stint_gps_arr = [];
        form.value.stint_gps_arr.push(value);
      }
      mpaState.showMap = false;
    };
    const gpsColumns = [
      {
        title: "经纬度",
        dataIndex: "latlng",
        key: "latlng",
        customRender: ({ record }) => {
          return record.lat + "-" + record.lng;
        },
      },
      {
        title: "范围 (米)",
        dataIndex: "range",
        key: "range",
        slots: { customRender: "range" },
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];

    // 指定地区参与 结束--------------------
    return {
      ...toRefs(state),
      ruleForm,
      form,
      rules,
      panes,
      changAwardContent,
      custimizesList,
      getcustimizesList,
      visible,
      provide,
      detail,
      submit,
      columns,
      data,
      listLoading,
      ploysVisible,
      done,
      ployDel,
      ployStatus,
      customRow,
      giftDone,
      editPloy,
      ploysComponents,
      ployUserDone,
      createUserPloy,
      userVisible,
      userComponents,
      delRegion,
      addCity,
      clearCityArr,
      selectArea,
      selectProvince,
      selectCity,
      gpsConfirm,
      gpsColumns,
      ...toRefs(mpaState),
      giftCompoents,
      template_type,
      onchangeCoupon,
    };
  },
};
</script>
